<template>
  <b-container class="main-container" style="margin-top: 0">
    <h4 style="padding-bottom: 5px" v-if="item">
      {{
        item.workload.asurite.fullName +
        " - " +
        item.workload.timePeriod.description
      }}
      <b-button v-if="canEdit" v-b-modal.approve-modal variant="primary" class="ml-2 pull-right">Change
        Status</b-button>
      <!-- <b-button v-if="canEdit" v-b-modal.edit-modal variant="primary" class="ml-2 pull-right">Edit Request</b-button> -->
    </h4>

    <b-modal id="approve-modal" title="Update Status" @ok="submitAffiliateWorkStatus">
      <p>Press 'OK' to mark this request with the selected status.</p>
      <p>
        You may also leave a note with this status change, which will be visible
        to the faculty member who made this request.
      </p>

      <b-form-group label="Status" label-class="control-label workload-course-label"
        :class="{ 'invalid-group': $v.form.statusId.$error }">
        <b-form-select :options="statuses" v-model="form.statusId" text-field="name" value-field="id" :class="{
          'form-control': true,
          'is-invalid': $v.form.statusId.$error,
        }"></b-form-select>
      </b-form-group>

      <b-form-group label="Notes" label-class="control-label workload-course-label">
        <b-form-textarea :rows="3" placeholder="(Optional) Enter notes..." v-model="form.notes"></b-form-textarea>
      </b-form-group>
    </b-modal>

    <b-modal id="edit-modal" title="Edit Request" v-model="openModal" size="lg" @ok.prevent="attemptSubmit = true"
      @cancel="openModal = false">
      <affiliate-work-request-form v-model="attemptSubmit" :item="item" :totalPercent="affiliatePercent" v-if="item"
        v-on:complete="saveAffiliateWork">
      </affiliate-work-request-form>

      <span v-if="$v.form.$error" class="span-feedback invalid-feedback">
        All fields must be filled out.
      </span>
    </b-modal>

    <b-row v-if="item">
      <b-col>
        <widget heading="Details">
          <b-row>
            <b-col>
              <dl>
                <dt>Current Status</dt>
                <dd>{{ item.currentStatus.name }}</dd>

                <dt>Total Percent</dt>
                <dd>{{ item.percent }}%</dd>

                <dt>Notes</dt>
                <dd>{{ item.notes }}</dd>

                <dt>Attachment</dt>
                <dd>
                  <template v-if="item.fileId">
                    <a target="_blank" :href="getFileHref(item.fileId)"><font-awesome-icon icon="download" />
                      {{ item.fileName }}</a>
                  </template>

                  <template v-else> No File </template>
                </dd>
              </dl>
            </b-col>
          </b-row>
        </widget>
        <widget heading="Status History">
          <status-history :statuses="item.statuses" status-field-name="name" />
        </widget>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import Widget from "../../components/widget"
import StatusHistory from "../../components/workloads/status-history"
import AffiliateWorkRequestForm from "../../components/workloads/affiliate-work-request-form"
import roleChecks from "../../misc/role-checks"
import { required } from "vuelidate/lib/validators"
import affiliateWorkApi from "../../api/affiliateWork.js"
import ToastrSettings from "../../settings/toastr-settings"
import toastr from "toastr"

export default {
  mixins: [roleChecks],
  //   name: "BuyoutDetails",
  data() {
    return {
      statuses: [],
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" },

      openModal: false,
      attemptSubmit: false,
      item: null,
      form: {
        id: 0,
        statusId: 0,
        notes: ""
      }
    }
  },

  props: {
    id: {
      required: true
    }
  },

  components: {
    widget: Widget,
    StatusHistory,
    AffiliateWorkRequestForm
  },

  validations: {
    form: {
      statusId: { required },
      notes: { required }
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      files: state => state.workloads.files
    }),

    affiliatePercent: function () {
      return this.adminRequest
        ? _.filter(this.adminRequest.workload.workloadTypes, type => {
          return type.workloadTypeDefinition.name === "Affiliate Work"
        })[0].value * 100
        : 0
    },

    canEdit: function () {
      if (this.isAffiliateRequestsManager) return true

      return false
    }
  },

  methods: {
    ...mapActions("workloads"),

    setForm: function (affiliateWorkRequest) {
      // set values
      this.form = affiliateWorkRequest
    },

    load: function () {
      affiliateWorkApi
        .getById(this.id)
        .then(response => {
          this.item = response.data
          this.form.statusId = this.item.affiliateWorkStatusDefinitionId
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    getFileHref: function (fileId) {
      return process.env.VUE_APP_BASE_URI + "/api/files/" + fileId
    },

    submitAffiliateWorkStatus() {
      let updatedRequest = {
        affiliateWorkRequestId: this.item.id,
        affiliateWorkStatusDefinitionId: this.form.statusId,
        notes: this.form.notes
      }

      affiliateWorkApi.postStatus(updatedRequest).then(() => {
        // affiliateWorkApi.statusEmail(this.item.id)
        toastr.options = ToastrSettings
        toastr.success("The request has been saved.", "Success")
        this.load()
      })
    },

    saveAffiliateWork(request) {
      if (request) {
        this.attemptSubmit = false
        affiliateWorkApi.updateRequest(request).then(() => {
          toastr.options = ToastrSettings
          toastr.success("The request has been saved.", "Success")
          this.load()
        })
        this.openModal = false
      }
    }
  },

  created() {
    affiliateWorkApi
      .getById(this.id)
      .then(response => {
        this.item = response.data
        this.form.statusId = this.item.affiliateWorkStatusDefinitionId
      })
      .catch(function (error) {
        console.log(error)
      })

    affiliateWorkApi.getStatusDefinitions().then(response => {
      this.statuses = response.data
    })
  }
}
</script>

<style scoped>
.main-container {
  max-width: 100%;
  margin-top: 10px;
}
</style>
